import { createAction } from '../../../../../store.model';
import { FilterOptions } from '../model/filter-options.model';
import { ActionType } from '../transcript-summary.action';

export interface FilterSummary {
    opts?: FilterOptions;
}

export const filterSummary = createAction<ActionType, FilterSummary>(
    ActionType.COACHING_DETAIL__TS__FILTER_SUMMARY,
);
